import { cn } from "@/lib/utils";
import Link from "next/link";
import type { ReactNode } from "react";

interface NavLinkProps {
  id?: string;
  href?: string;
  className?: string;
  children: ReactNode;
}

export const NavLink = ({ id, href, className, children }: NavLinkProps) => {
  const navLinkClassName = cn(
    "nav-link transition duration-200 after:rounded-md after:bg-lightGray font-semibold",
    className,
  );

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // If href is provided, render a Link component
  if (href) {
    return (
      <Link href={href} className={navLinkClassName}>
        {children}
      </Link>
    );
  }

  // If id is provided, render a button for smooth scrolling
  if (id) {
    return (
      <button
        onClick={() => scrollToSection(id)}
        className={cn(navLinkClassName, "w-min text-nowrap")}
        type="button"
      >
        {children}
      </button>
    );
  }

  // Fallback for when neither href nor id is provided
  return <span className={navLinkClassName}>{children}</span>;
};
